import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-ff-training-videos',
    templateUrl: './fr-training-videos.component.html',
    styleUrls: ['./fr-training-videos.component.scss']
})
export class FrTrainingVideosComponent implements OnInit {

    videoModel: any[] = [];
    displaySelectedVideo = false;
    selectedVideo = null;
    selectedVideoLink: any;

    constructor(private sanitizer: DomSanitizer) {
    }

    ngOnInit(): void {
        this.videoModel = [
            {title: 'How to Login & Logout', videoLink: 'https://www.powtoon.com/embed/bYK077wjPiv/'},
            {title: 'How to track your shipment without Login', videoLink: 'https://www.powtoon.com/embed/fQxBur6FBzV'},
            {title: 'View your Booking Summary', videoLink: 'https://www.powtoon.com/embed/bXVdWEaDKcC/'},
            {title: 'Check your Shipment Details', videoLink: 'https://www.powtoon.com/embed/bO7LC8xZfSw/'},
            {title: 'Shipment Tracking', videoLink: 'https://www.powtoon.com/embed/dkpuRaAJBlz/'},
            {title: 'View Invoice & Documents', videoLink: 'https://www.powtoon.com/embed/dgZNtZNbGzu/'},
            {title: 'Check your Statement of accounts', videoLink: 'https://www.powtoon.com/embed/djPYAmj9YqC/'},
            {title: 'View in-app Notifications', videoLink: 'https://www.powtoon.com/embed/d2R6MQfFrL0/'},
            {title: 'Add online shipping instruction (SI)', videoLink: 'https://www.powtoon.com/embed/cOtkmWED13S/'}
        ];
    }


    openAndPlayVideo(videoObj: any) {
        this.selectedVideoLink = this.sanitizer.bypassSecurityTrustResourceUrl(videoObj?.videoLink);
        this.selectedVideo = videoObj;
        this.displaySelectedVideo = true;
    }


}
